/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProcessingRequest
 */
export interface ReportProcessingRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportProcessingRequest
     */
    id?: string;
}

/**
 * Check if a given object implements the ReportProcessingRequest interface.
 */
export function instanceOfReportProcessingRequest(value: object): value is ReportProcessingRequest {
    return true;
}

export function ReportProcessingRequestFromJSON(json: any): ReportProcessingRequest {
    return ReportProcessingRequestFromJSONTyped(json, false);
}

export function ReportProcessingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProcessingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ReportProcessingRequestToJSON(value?: ReportProcessingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

